module.exports = "<div class=\"app-spinner\"></div>\n"